import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Header } from './shared/components/header/header';
import { Footer } from './shared/components/footer/footer';
import { SearchOverlayComponent } from './shared/components/search-overlay/search-overlay.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header, Footer, SearchOverlayComponent],
  template: `
    <app-search-overlay></app-search-overlay>
    <app-header></app-header>
    <main>
      <router-outlet />
    </main>
    <app-footer></app-footer>
  `,
  styles: ``
})
export class AppComponent {
  title = 'imat.mk';
}
